export class PreviewRequest {
    private selected: string[];
    private shouldSend: boolean;

    constructor(selected: string[], shouldSend: boolean = false) {
        this.selected = selected;
        this.shouldSend = shouldSend;
    }
}